// extracted by mini-css-extract-plugin
export default {"container":"DamageDisclosurePage_container__7+Mza"};